module.exports = __webpack_public_path__ + "static/media/S1P2_family-history.ad6ad89e.mp3";